/**
 * McCluskey Pottery - Main JavaScript (Shopify Theme)
 * Adapted from WordPress/WooCommerce to Shopify Liquid + Cart API
 *
 * Handles: scroll animations, Shopify cart (AJAX), cart drawer,
 * quick view, gallery lightbox, filtering, contact form, notifications.
 */

(function () {
  'use strict';

  // ===== HEADER SCROLL EFFECT =====
  var header = document.getElementById('header');
  if (header) {
    var lastScrollY = 0;
    var ticking = false;

    function onHeaderScroll() {
      lastScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(function () {
          if (lastScrollY > 50) {
            header.classList.add('scrolled');
          } else {
            header.classList.remove('scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ===== MOBILE MENU TOGGLE =====
  var mobileToggle = document.getElementById('mobileToggle');
  var navLinks = document.querySelector('.nav-links');
  var headerNav = document.querySelector('.header .nav');

  if (mobileToggle && navLinks) {
    mobileToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
      mobileToggle.classList.toggle('active');
      var expanded = navLinks.classList.contains('open');
      mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (headerNav) {
        headerNav.classList.toggle('mobile-open');
      }
    });

    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.classList.remove('open');
        mobileToggle.classList.remove('active');
        mobileToggle.setAttribute('aria-expanded', 'false');
        if (headerNav) {
          headerNav.classList.remove('mobile-open');
        }
      });
    });
  }

  // ===== SCROLL REVEAL ANIMATIONS (IntersectionObserver) =====

  // Add reveal classes to all homepage sections
  var revealSelectors = [
    '.collection-intro',
    '.collection-grid-section',
    '.story-teaser',
    '.testimonial-banner',
    '.featured-products',
    '.craft-process',
    '.story-section',
    '.process-section',
    '.gallery-section',
    '.markets-section',
    '.contact-section'
  ];

  revealSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el.classList.contains('reveal') && !el.classList.contains('reveal-left') && !el.classList.contains('reveal-right')) {
        el.classList.add('reveal');
      }
    });
  });

  // Use IntersectionObserver for scroll reveals
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-stagger').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show everything immediately
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-stagger').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // ===== SUBTLE PARALLAX =====
  if (!prefersReducedMotion) {
    var parallaxElements = document.querySelectorAll('.hero-portrait__image, .story-teaser__image-wrap img');

    if (parallaxElements.length > 0) {
      var parallaxTicking = false;

      function updateParallax() {
        var scrollTop = window.scrollY;

        parallaxElements.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          var elementCenter = rect.top + rect.height / 2;
          var viewportCenter = window.innerHeight / 2;
          var offset = (elementCenter - viewportCenter) * 0.05;

          el.style.transform = 'translateY(' + offset + 'px)';
        });

        parallaxTicking = false;
      }

      window.addEventListener('scroll', function () {
        if (!parallaxTicking) {
          requestAnimationFrame(updateParallax);
          parallaxTicking = true;
        }
      }, { passive: true });
    }
  }

  // ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;

      var targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        var headerHeight = header ? header.offsetHeight : 0;
        var targetPosition = targetElement.offsetTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // ===== SHOPIFY CART API =====

  /**
   * Fetch the current cart state from Shopify.
   * Returns a promise that resolves with the cart JSON object.
   */
  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  /**
   * Format a Shopify price integer (cents) into a display string.
   * Shopify stores prices in the smallest currency unit (e.g. pence for GBP).
   */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    // Use the store currency symbol. Defaults to pound sign for McCluskey Pottery.
    return '\u00A3' + amount;
  }

  // ===== CART DRAWER =====
  var cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  var cartDrawerItems = document.getElementById('cartDrawerItems');
  var cartCount = document.getElementById('cartCount');
  var cartDrawerTotal = document.getElementById('cartDrawerTotal');

  function openCartDrawer() {
    if (cartDrawerOverlay) {
      cartDrawerOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      refreshCartDrawer();
    }
  }

  function closeCartDrawer() {
    if (cartDrawerOverlay) {
      cartDrawerOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function (e) {
      if (e.target === cartDrawerOverlay) {
        closeCartDrawer();
      }
    });
  }

  // Close cart drawer on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawerOverlay && cartDrawerOverlay.classList.contains('open')) {
      closeCartDrawer();
    }
  });

  /**
   * Refresh cart drawer contents from Shopify /cart.js
   */
  function refreshCartDrawer() {
    fetchCart()
      .then(function (cart) {
        updateCartDrawerUI(cart);
      })
      .catch(function (error) {
        console.error('Cart refresh error:', error);
      });
  }

  /**
   * Update the cart drawer DOM with cart data from Shopify.
   */
  function updateCartDrawerUI(cart) {
    // Update cart count badge with pulse animation
    if (cartCount) {
      var prevCount = parseInt(cartCount.textContent, 10) || 0;
      var newCount = cart.item_count || 0;
      cartCount.textContent = newCount;

      if (newCount !== prevCount && newCount > 0) {
        cartCount.classList.remove('pulse');
        // Force reflow to restart animation
        void cartCount.offsetWidth;
        cartCount.classList.add('pulse');
      }
    }

    // Update cart total
    if (cartDrawerTotal) {
      cartDrawerTotal.textContent = formatMoney(cart.total_price);
    }

    // Build cart items HTML
    if (cartDrawerItems) {
      if (cart.items && cart.items.length > 0) {
        var html = '';
        cart.items.forEach(function (item, index) {
          var itemKey = item.key;
          var imageTag = item.image
            ? '<img src="' + getSizedImageUrl(item.image, '120x120') + '" alt="' + escapeHtml(item.title) + '">'
            : '';

          html += '<div class="cart-item" data-key="' + itemKey + '">'
            + '  <div class="cart-item-image">' + imageTag + '</div>'
            + '  <div class="cart-item-details">'
            + '    <h4>' + escapeHtml(item.title) + '</h4>'
            + '    <p>' + formatMoney(item.price) + ' &times; ' + item.quantity + '</p>'
            + '    <div class="cart-item-qty">'
            + '      <button class="cart-qty-btn cart-qty-minus" data-key="' + itemKey + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">&minus;</button>'
            + '      <span class="cart-qty-value">' + item.quantity + '</span>'
            + '      <button class="cart-qty-btn cart-qty-plus" data-key="' + itemKey + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>'
            + '    </div>'
            + '  </div>'
            + '  <button class="cart-item-remove" data-key="' + itemKey + '" aria-label="Remove item">&times;</button>'
            + '</div>';
        });

        cartDrawerItems.innerHTML = html;
        attachCartItemListeners();
      } else {
        cartDrawerItems.innerHTML = '<div class="cart-empty">'
          + '<p>Your basket is empty</p>'
          + '<p style="font-size: 0.9rem; opacity: 0.7; margin-top: 0.5rem;">Add something lovely!</p>'
          + '</div>';
      }
    }

    // Update checkout button — swap between disabled button and active link
    var checkoutBtn = document.getElementById('checkoutBtn');
    if (checkoutBtn) {
      var parent = checkoutBtn.parentNode;
      if (cart.items && cart.items.length > 0) {
        if (checkoutBtn.tagName === 'BUTTON') {
          var link = document.createElement('a');
          link.href = '/checkout';
          link.className = 'cart-checkout';
          link.id = 'checkoutBtn';
          link.textContent = 'Proceed to Checkout';
          parent.replaceChild(link, checkoutBtn);
        }
      } else {
        if (checkoutBtn.tagName === 'A') {
          var btn = document.createElement('button');
          btn.className = 'cart-checkout';
          btn.id = 'checkoutBtn';
          btn.disabled = true;
          btn.textContent = 'Proceed to Checkout';
          parent.replaceChild(btn, checkoutBtn);
        }
      }
    }
  }

  /**
   * Attach event listeners to cart item quantity buttons and remove buttons.
   */
  function attachCartItemListeners() {
    // Remove buttons
    document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        updateCartItem(key, 0);
      });
    });

    // Decrease quantity
    document.querySelectorAll('.cart-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var currentQty = parseInt(this.dataset.qty, 10) || 1;
        updateCartItem(key, Math.max(0, currentQty - 1));
      });
    });

    // Increase quantity
    document.querySelectorAll('.cart-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var currentQty = parseInt(this.dataset.qty, 10) || 1;
        updateCartItem(key, currentQty + 1);
      });
    });
  }

  /**
   * Update the quantity of a cart line item via Shopify /cart/change.js
   * Setting quantity to 0 removes the item.
   */
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) {
          // On error, refresh cart from /cart.js instead
          return fetchCart();
        }
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.total_price !== 'undefined') {
          updateCartDrawerUI(cart);
          if (quantity === 0) {
            showNotification('Item removed from basket');
          }
        } else {
          // Fallback: refresh cart
          refreshCartDrawer();
        }
      })
      .catch(function (error) {
        console.error('Cart update error:', error);
        refreshCartDrawer();
      });
  }

  // Keep backward compat
  function updateCartLine(line, quantity) {
    // Convert line-based call to fetch + update approach
    fetchCart().then(function(cart) {
      if (cart.items && cart.items[line - 1]) {
        updateCartItem(cart.items[line - 1].key, quantity);
      } else {
        refreshCartDrawer();
      }
    });
  }

  // ===== ADD TO CART (AJAX) =====

  /**
   * Add a product variant to the Shopify cart via /cart/add.js
   *
   * @param {string|number} variantId - The Shopify variant ID
   * @param {string} productName - Display name for the notification
   * @param {number} [quantity=1] - Quantity to add
   */
  function addToCart(variantId, productName, quantity) {
    quantity = quantity || 1;
    productName = productName || 'Product';

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
        return response.json();
      })
      .then(function () {
        // Fetch updated cart to get new count
        return fetchCart();
      })
      .then(function (cart) {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
        showNotification(productName + ' added to basket!');
        // Open cart drawer to show the added item
        setTimeout(function () {
          openCartDrawer();
        }, 500);
      })
      .catch(function (error) {
        console.error('Add to cart error:', error);
        var msg = (error && error.description) ? error.description : 'Could not add to basket';
        showNotification(msg, 'error');
      });
  }

  // Event delegation for AJAX add-to-cart buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ajax-add-to-cart');
    if (!btn) return;

    e.preventDefault();

    var variantId = btn.dataset.variantId;
    var productName = btn.dataset.productName || 'Product';

    if (!variantId) {
      // Fallback: try to get the variant from a hidden input on the page
      var variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }
    }

    if (!variantId) {
      showNotification('Please select a product option', 'error');
      return;
    }

    // Add loading state
    var originalText = btn.textContent;
    btn.classList.add('loading');
    btn.textContent = 'Adding...';

    // Read quantity from product page input
    var qtyInput = btn.closest('form') ? btn.closest('form').querySelector('input[name="quantity"]') : null;
    if (!qtyInput) { qtyInput = document.querySelector('.product-quantity input[type="number"], input.qty, input[name="quantity"]'); }
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    addToCart(variantId, productName, qty).finally(function () {
      // Reset button after a short delay
      setTimeout(function () {
        btn.classList.remove('loading');
        btn.textContent = originalText;
      }, 1000);
    });
  });

  // ===== SHOP FILTER FUNCTIONALITY =====
  var filterButtons = document.querySelectorAll('.filter-btn[data-filter]');
  var shopItems = document.querySelectorAll('.shop-item[data-category]');

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var filter = this.dataset.filter;

      // Update active state
      filterButtons.forEach(function (btn) { btn.classList.remove('active'); });
      this.classList.add('active');

      // Filter items
      shopItems.forEach(function (item) {
        var category = item.dataset.category;
        if (filter === 'all' || category === filter) {
          item.style.display = '';
          item.style.animation = 'fadeUp 0.4s ease forwards';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  // Contact form is handled by inline script in sections/contact.liquid

  // ===== PRODUCT IMAGE GALLERY (Single Product Page) =====
  // Shopify product page: clicking thumbnails switches the main image.
  // Thumbnails use the .product-thumbnail class with a data-full-src attribute.
  // The main image is inside .main-product-image img.
  var mainProductImage = document.querySelector('.main-product-image img');

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product-thumbnail');
    if (!thumb || !mainProductImage) return;

    var fullSrc = thumb.dataset.fullSrc;
    if (fullSrc) {
      mainProductImage.src = fullSrc;
      mainProductImage.alt = thumb.getAttribute('alt') || thumb.querySelector('img')?.getAttribute('alt') || '';

      // Update active state on thumbnails
      document.querySelectorAll('.product-thumbnail').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    }
  });

  // Variant selector is handled by inline script in sections/main-product.liquid

  // ===== GALLERY PAGE LIGHTBOX =====
  var lightbox = document.getElementById('galleryLightbox');
  var lightboxImage = document.getElementById('lightboxImage');
  var lightboxTitle = document.getElementById('lightboxTitle');
  var lightboxDescription = document.getElementById('lightboxDescription');
  var lightboxClose = document.querySelector('.lightbox-close');
  var lightboxPrev = document.querySelector('.lightbox-prev');
  var lightboxNext = document.querySelector('.lightbox-next');
  var lightboxCurrent = document.getElementById('lightboxCurrent');
  var lightboxTotal = document.getElementById('lightboxTotal');

  var currentLightboxIndex = 0;

  function initGalleryLightbox() {
    var allGalleryItems = document.querySelectorAll('.gallery-masonry-item:not(.hidden) .gallery-item-inner');

    if (!allGalleryItems.length || !lightbox) return;

    allGalleryItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    // Update total count
    if (lightboxTotal) {
      lightboxTotal.textContent = allGalleryItems.length;
    }
  }

  function openLightbox(index) {
    if (!lightbox) return;

    var visibleItems = document.querySelectorAll('.gallery-masonry-item:not(.hidden) .gallery-item-inner');
    currentLightboxIndex = index;

    updateLightboxContent(visibleItems[currentLightboxIndex]);

    lightbox.classList.add('active');
    document.body.classList.add('lightbox-open');

    // Update counter
    if (lightboxCurrent) {
      lightboxCurrent.textContent = currentLightboxIndex + 1;
    }
    if (lightboxTotal) {
      lightboxTotal.textContent = visibleItems.length;
    }
  }

  function closeLightbox() {
    if (!lightbox) return;

    lightbox.classList.remove('active');
    document.body.classList.remove('lightbox-open');
  }

  function updateLightboxContent(item) {
    if (!item) return;

    var src = item.dataset.src;
    var titleEl = item.querySelector('h4');
    var descEl = item.querySelector('span:not(.zoom-icon)');
    var title = item.dataset.title || (titleEl ? titleEl.textContent : '') || 'Gallery Item';
    var description = item.dataset.description || (descEl ? descEl.textContent : '') || '';

    // Check if there is an actual image or just a placeholder
    var hasImage = src && src !== 'undefined' && src !== '';

    if (lightboxImage) {
      if (hasImage) {
        lightboxImage.src = src;
        lightboxImage.alt = title;
        lightboxImage.style.display = 'block';
      } else {
        // Placeholder items with no real image
        lightboxImage.src = '';
        lightboxImage.style.display = 'none';
      }
    }

    if (lightboxTitle) {
      lightboxTitle.textContent = title;
    }

    if (lightboxDescription) {
      lightboxDescription.textContent = description;
    }
  }

  function navigateLightbox(direction) {
    var visibleItems = document.querySelectorAll('.gallery-masonry-item:not(.hidden) .gallery-item-inner');
    var total = visibleItems.length;

    if (total === 0) return;

    currentLightboxIndex = (currentLightboxIndex + direction + total) % total;

    updateLightboxContent(visibleItems[currentLightboxIndex]);

    if (lightboxCurrent) {
      lightboxCurrent.textContent = currentLightboxIndex + 1;
    }
  }

  // Lightbox event listeners
  if (lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }

  if (lightboxPrev) {
    lightboxPrev.addEventListener('click', function () { navigateLightbox(-1); });
  }

  if (lightboxNext) {
    lightboxNext.addEventListener('click', function () { navigateLightbox(1); });
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  }

  // Keyboard navigation for lightbox
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('active')) return;

    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        navigateLightbox(-1);
        break;
      case 'ArrowRight':
        navigateLightbox(1);
        break;
    }
  });

  // Initialize lightbox
  initGalleryLightbox();

  // ===== GALLERY CATEGORY FILTERING =====
  var galleryFilterButtons = document.querySelectorAll('.gallery-page-section .filter-btn[data-filter]');
  var masonryItems = document.querySelectorAll('.gallery-masonry-item[data-category]');
  var emptyState = document.getElementById('galleryEmptyState');

  if (galleryFilterButtons.length && masonryItems.length) {
    galleryFilterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = this.dataset.filter;

        // Update active state
        galleryFilterButtons.forEach(function (btn) { btn.classList.remove('active'); });
        this.classList.add('active');

        var visibleCount = 0;

        // Filter masonry items with animation
        masonryItems.forEach(function (item, index) {
          var category = item.dataset.category;

          if (filter === 'all' || category === filter) {
            item.classList.remove('hidden');
            item.style.opacity = '0';
            item.style.transform = 'scale(0.9)';

            // Staggered animation
            setTimeout(function () {
              item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              item.style.opacity = '1';
              item.style.transform = 'scale(1)';
            }, index * 50);

            visibleCount++;
          } else {
            item.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
            item.style.opacity = '0';
            item.style.transform = 'scale(0.9)';

            setTimeout(function () {
              item.classList.add('hidden');
            }, 200);
          }
        });

        // Show/hide empty state
        if (emptyState) {
          emptyState.style.display = (visibleCount === 0) ? 'block' : 'none';
        }

        // Update lightbox total after filtering
        setTimeout(function () {
          if (lightboxTotal) {
            var visible = document.querySelectorAll('.gallery-masonry-item:not(.hidden)');
            lightboxTotal.textContent = visible.length;
          }
        }, 300);
      });
    });
  }

  // ===== QUICK VIEW =====

  /**
   * Create the quick view modal element if it does not already exist.
   */
  function createQuickViewModal() {
    if (document.getElementById('quickViewOverlay')) return;

    var modal = document.createElement('div');
    modal.id = 'quickViewOverlay';
    modal.className = 'quick-view-overlay';
    modal.innerHTML = ''
      + '<button class="quick-view-close" aria-label="Close">&times;</button>'
      + '<div class="quick-view-modal">'
      + '  <div class="quick-view-image">'
      + '    <img src="" alt="">'
      + '  </div>'
      + '  <div class="quick-view-content">'
      + '    <h2 class="quick-view-title"></h2>'
      + '    <div class="quick-view-price price"></div>'
      + '    <div class="quick-view-description description"></div>'
      + '    <div class="quick-view-actions" style="display: flex; gap: 1rem; margin-top: auto;">'
      + '      <a href="#" class="quick-view-link button" style="flex: 1; text-align: center;">View Details</a>'
      + '      <button class="quick-view-add-to-cart add-to-cart ajax-add-to-cart" data-variant-id="" data-product-name="">Add to Basket</button>'
      + '    </div>'
      + '  </div>'
      + '</div>';

    document.body.appendChild(modal);

    // Close button
    modal.querySelector('.quick-view-close').addEventListener('click', closeQuickView);

    // Close on overlay click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeQuickView();
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closeQuickView();
      }
    });
  }

  /**
   * Open the quick view modal and populate it with product data
   * fetched from Shopify's product JSON endpoint.
   *
   * @param {string} productHandle - The Shopify product handle (URL slug)
   */
  function openQuickView(productHandle) {
    var overlay = document.getElementById('quickViewOverlay');
    if (!overlay) return;

    // Show modal in loading state
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    // Reset content while loading
    overlay.querySelector('.quick-view-title').textContent = 'Loading...';
    overlay.querySelector('.quick-view-price').textContent = '';
    overlay.querySelector('.quick-view-description').textContent = '';
    overlay.querySelector('.quick-view-image img').src = '';

    // Fetch product data from Shopify product JSON endpoint
    fetch('/products/' + productHandle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      })
      .then(function (product) {
        var image = product.featured_image || (product.images && product.images.length > 0 ? product.images[0] : '');
        var price = product.price;
        var comparePrice = product.compare_at_price;
        var firstVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
        var variantId = firstVariant ? firstVariant.id : '';

        overlay.querySelector('.quick-view-image img').src = image;
        overlay.querySelector('.quick-view-image img').alt = product.title;
        overlay.querySelector('.quick-view-title').textContent = product.title;

        // Build price HTML
        var priceHtml = formatMoney(price);
        if (comparePrice && comparePrice > price) {
          priceHtml = '<span class="compare-price" style="text-decoration: line-through; opacity: 0.6; margin-right: 0.5rem;">'
            + formatMoney(comparePrice) + '</span> ' + formatMoney(price);
        }
        overlay.querySelector('.quick-view-price').innerHTML = priceHtml;

        overlay.querySelector('.quick-view-description').innerHTML =
          product.description || 'Handcrafted with care in Limavady, Northern Ireland.';

        overlay.querySelector('.quick-view-link').href = '/products/' + product.handle;
        overlay.querySelector('.quick-view-add-to-cart').dataset.variantId = variantId;
        overlay.querySelector('.quick-view-add-to-cart').dataset.productName = product.title;
      })
      .catch(function (error) {
        console.error('Quick view error:', error);
        showNotification('Could not load product details', 'error');
        closeQuickView();
      });
  }

  function closeQuickView() {
    var overlay = document.getElementById('quickViewOverlay');
    if (overlay) {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  // Event delegation for quick view buttons (use data-product-handle)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-view-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var productHandle = btn.dataset.productHandle;
    if (productHandle) {
      openQuickView(productHandle);
    }
  });

  // Initialize quick view modal
  createQuickViewModal();

  // ===== NOTIFICATIONS =====

  /**
   * Show a toast notification in the bottom-right corner.
   *
   * @param {string} message - The message to display
   * @param {string} [type='success'] - 'success' or 'error'
   */
  function showNotification(message, type) {
    type = type || 'success';

    // Remove existing notification
    var existing = document.querySelector('.mccluskey-notification');
    if (existing) {
      existing.remove();
    }

    var notification = document.createElement('div');
    notification.className = 'mccluskey-notification ' + type;
    notification.innerHTML = '<span>' + escapeHtml(message) + '</span>'
      + '<button class="notification-close" aria-label="Dismiss">&times;</button>';

    // Inline styles for portability
    Object.assign(notification.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      padding: '1rem 1.5rem',
      background: type === 'error' ? '#c4673d' : '#3d5a3d',
      color: '#f5f0e6',
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1rem',
      borderRadius: '4px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      animation: 'slideInRight 0.3s ease'
    });

    document.body.appendChild(notification);

    // Close button
    notification.querySelector('.notification-close').addEventListener('click', function () {
      notification.remove();
    });

    // Auto remove after 4 seconds
    setTimeout(function () {
      if (notification.parentNode) {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(function () { notification.remove(); }, 300);
      }
    }, 4000);
  }

  // Expose showNotification globally so Liquid templates can call it if needed
  window.mccluskeyShowNotification = showNotification;

  // ===== CSS ANIMATION KEYFRAMES (injected once) =====
  var animStyle = document.createElement('style');
  animStyle.textContent = ''
    + '@keyframes slideInRight {'
    + '  from { transform: translateX(100%); opacity: 0; }'
    + '  to { transform: translateX(0); opacity: 1; }'
    + '}'
    + '@keyframes slideOutRight {'
    + '  from { transform: translateX(0); opacity: 1; }'
    + '  to { transform: translateX(100%); opacity: 0; }'
    + '}'
    + '@keyframes fadeUp {'
    + '  from { opacity: 0; transform: translateY(20px); }'
    + '  to { opacity: 1; transform: translateY(0); }'
    + '}'
    + '.notification-close {'
    + '  background: none;'
    + '  border: none;'
    + '  color: inherit;'
    + '  font-size: 1.2rem;'
    + '  cursor: pointer;'
    + '  opacity: 0.7;'
    + '  transition: opacity 0.2s;'
    + '}'
    + '.notification-close:hover {'
    + '  opacity: 1;'
    + '}'
    + '.ajax-add-to-cart.loading {'
    + '  opacity: 0.7;'
    + '  pointer-events: none;'
    + '}';
  document.head.appendChild(animStyle);

  // ===== UTILITY HELPERS =====

  /**
   * Escape HTML entities for safe insertion into innerHTML.
   */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /**
   * Get a Shopify CDN-sized image URL.
   * Replaces the file extension portion with _<size>.<ext>
   *
   * @param {string} src - Original image URL
   * @param {string} size - Desired size (e.g. '120x120', '300x300')
   * @returns {string} Resized image URL
   */
  function getSizedImageUrl(src, size) {
    if (!src) return '';

    // Remove any existing size suffix
    var match = src.match(/(.+)\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
    if (match) {
      return match[1] + '_' + size + '.' + match[2] + (match[3] || '');
    }

    return src;
  }

  // ===== INIT =====

  // Refresh cart count on page load
  fetchCart()
    .then(function (cart) {
      if (cartCount) {
        cartCount.textContent = cart.item_count || 0;
      }
    })
    .catch(function () {
      // Silently fail - cart count will remain at server-rendered value
    });

  // ===== RE-OBSERVE DYNAMICALLY LOADED SECTIONS =====
  // MutationObserver to catch sections added after initial load
  if ('IntersectionObserver' in window && typeof revealObserver !== 'undefined') {
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.matches && (node.matches('.reveal') || node.matches('.reveal-left') || node.matches('.reveal-right') || node.matches('.reveal-stagger'))) {
              revealObserver.observe(node);
            }
            var children = node.querySelectorAll ? node.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-stagger') : [];
            children.forEach(function (child) {
              revealObserver.observe(child);
            });
          }
        });
      });
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Jewellery "Coming Soon" card is hardcoded in Liquid templates
  // (collection-grid.liquid and main-list-collections.liquid)

  console.log('McCluskey Pottery JS initialized (Shopify)');

})();
